import vtg from "./imgs/vtg.png";
import nyt from "./imgs/nyt.png";
import ecom from "./imgs/ecom.png";
import quizz1 from "./imgs/images/quizz1.png";
import quizz2 from "./imgs/images/quizz2.png";
import quizz3 from "./imgs/images/quizz3.png";
import quizz4 from "./imgs/images/quizz4.png";
import quizz5 from "./imgs/images/quizz5.png";
import quizz6 from "./imgs/images/quizz6.png";
import quizz7 from "./imgs/images/quizz7.png";
import quizz8 from "./imgs/images/quizz8.png";
import quizz9 from "./imgs/images/quizz9.png";
import quizz10 from "./imgs/images/quizz10.png";
import quizz11 from "./imgs/images/quizz11.png";
import quizz12 from "./imgs/images/quizz12.png";
import duizz1 from "./imgs/images/dating1.png";
import duizz2 from "./imgs/images/dating2.png";
import duizz3 from "./imgs/images/dating3.png";
import duizz4 from "./imgs/images/dating4.png";
import duizz5 from "./imgs/images/dating5.png";
import duizz6 from "./imgs/images/dating6.png";
import duizz7 from "./imgs/images/dating7.png";
import duizz8 from "./imgs/images/dating8.png";
import duizz9 from "./imgs/images/dating9.png";
import duizz10 from "./imgs/images/dating10.png";
import { SiReact } from "react-icons/si";
import { SiAngular } from "react-icons/si";
import { SiRedux } from "react-icons/si";
import { SiHtml5 } from "react-icons/si";
import { SiCss3 } from "react-icons/si";
import { SiJavascript } from "react-icons/si";
import { SiTypescript } from "react-icons/si";
import { SiJquery } from "react-icons/si";
import { SiNodedotjs } from "react-icons/si";
import { SiMongodb } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiSpringboot } from "react-icons/si";
import { SiMysql } from "react-icons/si";
import { BsGit } from "react-icons/bs";
import { BsFiletypeScss } from "react-icons/bs";
import { TbLetterC } from "react-icons/tb";
import { FaJava } from "react-icons/fa";

let store = [
  ["Virtual Tourist Guide", vtg, "https://virtual-tou.web.app/"],
  [
    "Dating App",
    [
      duizz1,
      duizz2,
      duizz3,
      duizz4,
      duizz5,
      duizz6,
      duizz7,
      duizz8,
      duizz9,
      duizz10,
    ],
  ],
  ["NYTimes Articles", nyt, "https://project-nyt-6d1bf.web.app/"],
  ["Ecommerce website", ecom, "https://top-barand-basket.web.app/"],

  [
    "Quizz App",
    [
      quizz1,
      quizz2,
      quizz3,
      quizz4,
      quizz5,
      quizz6,
      quizz7,
      quizz8,
      quizz9,
      quizz10,
      quizz11,
      quizz12,
    ],
  ],
  ["TimerApp", null, "https://timer-680cc.web.app"],
];

export let details = [
  {
    description:
      "TimerApp is easy to use stop watch webapp. You can pause,resume and stop the timer.",
    online: true,
    tech: ["React"],
    link: "https://timer-680cc.web.app",
  },
  {
    description:
      "QuizApp is a collection of number of different types of quizzes. A user can access/play the entire quiz. Based on user’s score title will be awarded to user.",
    online: false,
    tech: ["Angular", "Angular-Material", "SCSS"],
    link: "",
  },
  {
    description:
      "This website is designed to give the best user experience in purchasing clothes. Admin can add and remove the products and can see order details. Google Pay API is used for online payment.",
    online: true,
    tech: ["React.js", "Firebase"],
    link: "https://top-barand-basket.web.app/",
  },
  {
    description:
      "This project is built on top of the New York Times API. It gives information about different articles in New York Times. The articles are categorized by their type.",
    online: true,
    tech: ["React.js", "Material UI"],
    link: "https://project-nyt-6d1bf.web.app/",
  },
  {
    description:
      "Dating App help people to connect with their opposite gender. Chatroom is available to chat. Only connected friends can chat.Premium users can see 10 profiles per hour and 5 for normal user.",
    online: false,
    tech: ["Angular", "SpringBoot", "CSS", "Angular-Material"],
    link: "",
  },
  {
    description:
      "This project is Bagalkot's virtual guide. It gives information about nearby tourist places, accommodations, and food. Recommendation and Voice navigation are the top features of this project.",
    online: true,
    tech: ["React.js", "Firebase"],
    link: "https://virtual-tou.web.app/",
  },
];

export let symbols = {
  fe: [
    [<SiReact className="skillsContainerIcon" />, "React.js"],
    [<SiAngular className="skillsContainerIcon" />, "Angular"],
    [<SiRedux className="skillsContainerIcon" />, "Redux"],
    [<SiHtml5 className="skillsContainerIcon" />, "Html"],
    [<SiCss3 className="skillsContainerIcon" />, "CSS"],
    [<SiJavascript className="skillsContainerIcon" />, "Javascript"],
    [<SiTypescript className="skillsContainerIcon" />, "Typescript"],
    [<BsFiletypeScss className="skillsContainerIcon" />, ""],
    [<SiJquery className="skillsContainerIcon" />, "jQuery"],
  ],
  be: [
    [<SiNodedotjs className="skillsContainerIcon" />, "Node.js"],
    [<SiMongodb className="skillsContainerIcon" />, "MongoDB"],
    [<SiExpress className="skillsContainerIcon" />, "Express.js"],
    [<SiSpringboot className="skillsContainerIcon" />, "SpringBoot"],
    [<SiMysql className="skillsContainerIcon" />, "SQL"],
  ],
  vc: [[<BsGit className="skillsContainerIcon" />, "Git"]],
  core: [
    [<TbLetterC className="skillsContainerIcon" />, ""],
    [<FaJava className="skillsContainerIcon" />, "Java"],
  ],
};

export default store;
